import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import {
  BaseStats,
  ActiveUser,
  TopProduct,
  StoreInvoiceResponse,
  Transaction,
  StoreTransaction,
} from "@/types/data";

export const analyticsService = {
  async getBaseStats(): Promise<BaseStats> {
    const response = await axios.get(ApiRoutes.STATS);
    return response.data;
  },

  async getActiveUsers(): Promise<ActiveUser[]> {
    const response = await axios.get(ApiRoutes.USERS_ACTIVE);
    return response.data;
  },

  async getRevenue() {
    const response = await axios.get(ApiRoutes.REVENUE);
    return response.data;
  },

  async getTopProducts(customer?: string): Promise<TopProduct[]> {
    const url = customer
      ? `${ApiRoutes.PRODUCTS_TOP}?customer=${customer}`
      : ApiRoutes.PRODUCTS_TOP;
    const response = await axios.get(url);
    return response.data;
  },

  async getInvoices(): Promise<StoreInvoiceResponse[]> {
    const response = await axios.get(ApiRoutes.INVOICES);
    return response.data;
  },

  async getLiveTransactions(): Promise<Transaction[]> {
    const response = await axios.get<Transaction[]>(
      ApiRoutes.TRANSACTIONS_LIVE,
    );
    return response.data;
  },

  async getTransactionsPerStore(): Promise<StoreTransaction[]> {
    const response = await axios.get<StoreTransaction[]>(
      ApiRoutes.TRANSACTIONS_PER_STORE,
    );
    return response.data;
  },

  async getTransactions(customer?: string): Promise<Transaction[]> {
    const url = customer
      ? `${ApiRoutes.TRANSACTIONS}?customer=${customer}`
      : ApiRoutes.TRANSACTIONS;
    const response = await axios.get<Transaction[]>(url);
    return response.data;
  },
};
